import React, { FC } from 'react';
import { Helmet } from 'react-helmet';

import { AdimoProps } from './models';

const Adimo: FC<AdimoProps> = ({ url }) => (
  <Helmet>
    <script src={url} />
  </Helmet>
);

export default Adimo;
